import React, {useRef} from 'react'
import {useState, useEffect} from 'react'

const EditableNumberCell = ({
  index,
  className = '',
  piece,
  fieldName,
  placeholder,
  min = 0,
  onChangeValue,
  onBlurValue,
  statutLocaux,
  disabled = false,
}) => {
  const value = piece?.[fieldName]

  const isEditable =
    (piece?.statut === 'A_PROPO' || piece?.statut === 'PROPO') &&
    (statutLocaux == null || false) &&
    !piece?.isQuantityReached

  const normalizeNumber = (raw) => {
    let v = raw.replace(/[,;]/g, '.')
    v = v.replace(/[^0-9.\-]/g, '')

    const parts = v.split('.')

    if (parts.length > 2) {
      v = parts[0] + '.' + parts.slice(1).join('')
    }

    // Maximum 2 chiffres après la virgule
    const decimalIndex = v.indexOf('.')
    if (decimalIndex !== -1) {
      v = v.slice(0, decimalIndex + 1) +
          v.slice(decimalIndex + 1, decimalIndex + 3)
    }

    if (v.indexOf('-') > 0) {
      v = v.replace(/-/g, '')
    }

    return v
  }

  const [localValue, setLocalValue] = useState(value ?? '')
  const inputRef = useRef(null)
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if(!piece?.['isTypePiecePOT']){
      if (document.activeElement === inputRef.current) return
    }
    setLocalValue(value ?? '')
  }, [value])

  // Nettoyage du timer au démontage
  useEffect(() => {
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current)
    }
  }, [])

  const handleChange = (e) => {
    const normalized = normalizeNumber(e.target.value)
    setLocalValue(normalized)
    onChangeValue(normalized === '' ? null : normalized, piece.id)

    if( (fieldName === 'prixVenteProposeeHt' || fieldName === 'tauxRemise') && piece?.['isTypePiecePOT']){
        //debounce pour attendre 1000ms après la saisie => validation

        // Annule la validation précédente en attente
        if (debounceRef.current) clearTimeout(debounceRef.current)

        // Valide/corrige automatiquement 1000ms après la dernière frappe
          debounceRef.current = setTimeout(() => {
            const numValue = normalized === '' ? null : Number(normalized)
            onBlurValue?.(numValue, piece.immat, piece.id)
          }, 1000)
    }

  }

  const handleBlur = (e) => {
    if (debounceRef.current) clearTimeout(debounceRef.current)
    const normalized = normalizeNumber(e.target.value)
    const numValue = normalized === '' ? null : Number(normalized)
    setLocalValue(normalized)
    onBlurValue?.(numValue, piece.immat, piece.id)
  }

  return (
    <>
      {isEditable ? (
          <input
            ref={inputRef}
            type='text'
            inputMode='decimal'
            className={`form-control form-control-solid mb-3 mb-lg-0 ${className}`}
            name={`${fieldName}${index}`}
            placeholder={placeholder}
            value={localValue}
            min={min}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={disabled}
          />
      ) : (
        <p className='text-start ps-4 mt-4'>{value}</p>
      )}
    </>
  )
}

export {EditableNumberCell}
